import jqRequest from '../jqRequest'
import reportUrls from '../urls/report'

export default {
  // 获取报料详情
  getReportDetailById(data){
    return jqRequest.request(reportUrls.getDiscloseMaterialInfo, data);
  },
}